export const CREATE_AIRPLANE = "CREATE_AIRPLANE";
export const UPDATE_AIRPLANE = "UPDATE_AIRPLANE";
export const DELETE_AIRPLANE = "DELETE_AIRPLANE";
export const FETCH_AIRPLANES = "FETCH_AIRPLANES";
export const LISTEN_TO_SELECTED_AIRPLANE = "LISTEN_TO_SELECTED_AIRPLANE";
